import type { AccessDeniedCode } from 'api/helpers/subdivision'
import type { Router } from 'vue-router'
import { provideSubdivision } from 'api/helpers/subdivision'
import { i18n } from 'boot/i18n'
import { ROUTES } from 'src/presentation/shared/routes'
import { useSubdivisionStore } from 'stores/subdivision'

/** Один тост на волну одинаковых отказов (параллельные запросы экрана). */
const TOAST_THROTTLE_MS = 2000

/**
 * Связывает заголовок X-Subdivision-Id с выбором в профиле и реакции на
 * отказы бэкенда: подразделение не выбрано или недоступно — сбрасываем выбор
 * и ведём в профиль; нет права или действие только для сотрудников — тост.
 */
export function installSubdivision(router: Router) {
  const store = useSubdivisionStore()
  const lastToastAt = new Map<string, number>()

  function toastOnce(key: string, description: string, color: 'warning' | 'error') {
    const now = Date.now()
    if (now - (lastToastAt.get(key) ?? 0) < TOAST_THROTTLE_MS) return
    lastToastAt.set(key, now)

    useToast().add({
      description,
      color,
      icon: color === 'error' ? 'i-clarity-error-standard-line' : undefined,
    })
  }

  provideSubdivision({
    resolveSubdivisionId: () => store.headerValue,
    onSubdivisionRejected: () => {
      store.clearSelected()
      toastOnce('subdivision', i18n.global.t('error.subdivisionRequired'), 'warning')
      if (router.currentRoute.value.name !== ROUTES.PROFILE)
        void router.push({ name: ROUTES.PROFILE })
    },
    onAccessDenied: (code: AccessDeniedCode) => {
      const key = code === 'employee_required' ? 'error.employeeRequired' : 'error.forbidden'
      toastOnce(key, i18n.global.t(key), 'error')
    },
  })
}
